import React from 'react'
import IrregularInteraction from '../../IrregularInteraction'
import ItemImage from '../../ItemImage'
import image from '../../../assets/images/bedroom/item--laptop@3x.png'

const path =
  'M55.09,40.08a.66.66,0,0,0-.37-.46l-20.8-12a1.71,1.71,0,0,0-1.49-.08,1.42,1.42,0,0,0,.58-1V.73A.38.38,0,0,0,32.85.4h0l0,0,0,0L32.31.08a.49.49,0,0,0-.58,0L.7,18a1.45,1.45,0,0,0-.7,1.1V44.9a.41.41,0,0,0,.13.33l0,0,.6.34h0a.48.48,0,0,0,.34,0l-.27.16a.44.44,0,0,0-.25.37h0v1.59h0a.66.66,0,0,0,.37.46l20.8,12a1.7,1.7,0,0,0,1.53.06L54.82,42a.46.46,0,0,0,.26-.37h0V40.08Z'

const Laptop = props => (
  <IrregularInteraction
    path={path}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 55.09 60.41"
    {...props}
  >
    <ItemImage src={image} />
  </IrregularInteraction>
)

Laptop.propTypes = IrregularInteraction.propTypes

export default Laptop



// WEBPACK FOOTER //
// ./src/components/items/bedroom/Laptop.js